import { Outlet } from "react-router";
import AppShell from "./AppShell";

const DashboardLayout = () => {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
};

export default DashboardLayout;
